import { base } from 'api';
import { QuickMenuCreateType, QuickMenuUpdateType } from 'types';

const PATH = '/quick-menus';

const getAll = () => base.get(PATH);

const post = (data: QuickMenuCreateType) => base.post(PATH, data);

const put = ({ id, ...data }: QuickMenuUpdateType) =>
  base.put(`${PATH}/${id}`, data);

const del = (id: number) => base.delete(`${PATH}/${id}`);

const putOrder = (ids: number[]) => base.put(`${PATH}/order`, { ids });

export { getAll, post, put, del, putOrder };
